import * as React from 'react';

function Refresh(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M16.203 12.434c0 2.482-1.92 4.507-4.272 4.507-2.351 0-4.258-2.025-4.258-4.507 0-2.47 1.894-4.481 4.245-4.494v1.789l3.37-2.247L11.919 5v1.489A5.935 5.935 0 006 12.434c0 3.279 2.652 5.944 5.93 5.944a5.949 5.949 0 005.945-5.944h-1.672z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Refresh;
